import { getToken } from "../../helper/common";
import agent from "../services/agent";
import {
  CLEAR_UPDATE_ORGANISATION_ERROR,
  CLOSE_EDIT_ORGANISATION_MODAL,
  GET_ORGANISATION_DETAILS_PENDING,
  GET_ORGANISATION_DETAILS_SUCCESS,
  OPEN_EDIT_ORGANISATION_MODAL,
  ORGANISATION_DETAILS_ERROR,
  SET_ORGANISATION_DETAILS,
  UPDATE_ORGANISATION_ERROR,
  UPDATE_ORGANISATION_PENDING,
  UPDATE_ORGANISATION_SUCCESS,
} from "../organisationDetails/actionTypes";
import { showSnackbarStatus } from "../snackbar/actions";
import trimmedValues from "../../helper/trimmer";

export const getOrganisationDetailsPending = () => ({
  type: GET_ORGANISATION_DETAILS_PENDING,
});

export const setOrganisationDetails = (organisationData) => ({
  type: SET_ORGANISATION_DETAILS,
  payload: organisationData,
});

export const getOrganisationDetailsSuccess = () => ({
  type: GET_ORGANISATION_DETAILS_SUCCESS,
});

export const closeEditOrganisationModal = () => ({
  type: CLOSE_EDIT_ORGANISATION_MODAL,
});

export const openEditOrganisationModal = () => ({
  type: OPEN_EDIT_ORGANISATION_MODAL,
});

export const clearUpdateOrganisationError = () => ({
  type: CLEAR_UPDATE_ORGANISATION_ERROR,
});

export const updateOrganisationPending = () => ({
  type: UPDATE_ORGANISATION_PENDING,
});

export const updateOrganisationSuccess = () => ({
  type: UPDATE_ORGANISATION_SUCCESS,
});

export const updateOrganisationError = (errorMessage) => ({
  type: UPDATE_ORGANISATION_ERROR,
  payload: { errorMessage },
});

export const OrgDetailsError = (errorMessage) => ({
  type: ORGANISATION_DETAILS_ERROR,
  payload: { errorMessage },
});

export const getOrganisationDetails = (organisationId) => (dispatch) => {
  dispatch(getOrganisationDetailsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Organisation.getOrganisationDetails(accessToken, organisationId)
      .then((organisationDetails) => {
        dispatch(setOrganisationDetails(organisationDetails));
        dispatch(getOrganisationDetailsSuccess());
      })
      .catch((err) => {
        console.log("getOrganisationDetails server error", err);
        if (err && err.response) {
          const { message } = err.response.body;
          dispatch(OrgDetailsError(message));
          return;
        }
        else {
          const { message } = "Network Error";
          dispatch(OrgDetailsError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const updateOrganisation = (data) => (dispatch) => {
  const values = trimmedValues(data)

  dispatch(clearUpdateOrganisationError());
  dispatch(updateOrganisationPending());
  getToken(dispatch).then((accessToken) => {
    agent.Organisation.updateOrganisation(accessToken, values)
      .then((organisationId) => {
        dispatch(updateOrganisationSuccess());
        dispatch(closeEditOrganisationModal());
        dispatch(getOrganisationDetails(organisationId));
        dispatch(
          showSnackbarStatus("Organization details updated successfully")
        );
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateOrganisationError(message));
          return;
        } else {
          const message = "Network error";
          dispatch(updateOrganisationError(message));
        }
        console.log("Update organisation server error", err);
        // dispatch(updateOrganisationError(null));
        // dispatch(closeEditOrganisationModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};
